var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainzaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 35,
    viewBox: "0 0 148 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.609 20.4986H119.267L130.717 0L147.55 29.3959L142.595 34.5469L130.904 14.418L127.609 20.4986ZM7.43665 29.9198H14.2853V11.01H21.6873V5.54252H0V11.01H7.43665V29.9198ZM42.0657 29.9198H38.4932L34.1004 23.4424H30.3648V29.9198H23.5162V5.54252H34.5847C41.1912 5.54252 45.3419 8.99016 45.3419 14.5621C45.3419 18.1491 43.6124 20.7957 40.6032 22.2584L43.5375 26.5627L52.7537 5.54252H59.4985L69.2351 27.6781V5.54252H76.0837V29.9198H70.2211H69.2351H63.0958L61.1934 25.1836H50.955L49.0526 29.9198H45.8261H42.0657ZM34.1696 18.1142C37.0059 18.1142 38.4241 16.7909 38.4241 14.5621C38.4241 12.2985 37.0059 10.9752 34.1696 10.9752H30.3648V18.1142H34.1696ZM52.9612 20.0992L56.0742 12.2985L59.1872 20.0992H52.9612ZM94.1202 18.5321V5.54252H100.831V29.9198H95.1925L84.5045 16.9302V29.9198H77.7942V5.54252H83.4322L94.1202 18.5321ZM105.204 12.8613H112.654L102.97 29.845H137.165L132.994 22.6047H115.225L125.106 5.59475H101.37L105.204 12.8613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainzaLogo);
export default __webpack_public_path__ + "static/media/TrainzaLogo.b7ec636ea7aad176a263df7c10712f8d.svg";
export { ForwardRef as ReactComponent };